import "./index.css";

import App from "./App";
import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { theme } from "./theme/main";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <ConfigProvider
    theme={theme}
  >
    <Router>
      <App />
    </Router>
  </ConfigProvider>
);

reportWebVitals();
